import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export class HttpParams {
  method: HttpMethod;
  url: string;
  body?: any;
  responseType?: string;
  token?: string;
  withCredentials?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class RestService {
  protected http = inject(HttpClient);

  protected restApi(params: HttpParams, headers?: { [header: string]: string | string[] }): Observable<any> {
    headers = headers || { 'Content-Type': 'application/json' };
    const _options: any = { headers: new HttpHeaders({ ...headers }) };

    if (params.responseType) {
      _options.responseType = params.responseType;
    }

    if (params.withCredentials === true) {
      _options.withCredentials = true;
    }

    switch (params.method) {
      case HttpMethod.GET:
        return this.http.get(params.url, _options);
      case HttpMethod.POST:
        return this.http.post(params.url, params.body, _options);
      case HttpMethod.PUT:
        return this.http.put(params.url, params.body, _options);
      case HttpMethod.DELETE:
        return this.http.delete(params.url, _options);
      default:
        break;
    }
  }
}
